module.exports = __webpack_public_path__ + "img/roller-skating.1ad3a3ed.svg";